export default {
  codigo: 'Código',
  nome: 'Nome',
  tabela: {
    nome: 'Nome',
    codigo: 'Código',
  },
  titulo_modal: 'Agendamentos do Cliente',
};
